import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import ReactYT from '../../../Core/ReactYT';
import Link from '../../../Core/Link';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.secondary')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  padding: 50px 0px 60px;

  .hubspot-margin {
    margin: 25px auto;
  }

  ${Wrapper}.bottom & {
    padding-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

export const StyledBottomLink = styled(Link)`
  align-self: center;
  margin-top: 35px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-top: 55px;
  }
`;

export const Header = styled.div`
  // * Title Styling
  *:first-child {
    text-align: center;
    color: ${themeGet('colors.text-primary')};
    max-width: 1100px;
    margin: 0 auto 25px;

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      ${Wrapper}.bottom & {
        margin-bottom: 25px;
      }
    }
  }

  // * Subtitle Styling
  *:nth-child(2n) {
    font-weight: 500;
    color: ${themeGet('colors.text-primary')};
    text-align: center;
    font-size: 18px;
    letter-spacing: -0.41px;
    line-height: 24px;
    margin-bottom: 30px;

    max-width: 800px;
    margin-left: auto;
    margin-right: auto;

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-bottom: 70px;

      font-size: 22px;
      letter-spacing: -0.5px;
      line-height: 38px;

      ${Wrapper}.bottom & {
        margin-bottom: 50px;
      }
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;

  ${Wrapper}.bottom & {
    flex-direction: column-reverse;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    justify-content: space-around;

    ${Wrapper}.bottom & {
      flex-direction: row;

      &.right {
        flex-direction: row-reverse;
      }
    }

    &.right {
      flex-direction: row-reverse;
    }
  }
`;

// * Styling for the video
export const VideoWrapper = styled.div`
  position: relative;
  margin: 0 calc(-${themeGet('media.grid-gutter.2')} / 2) 48px;
  width: 100vw;
  height: 235px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    height: 260px;
  }

  @media only screen and (min-width: 540px) {
    height: 280px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    margin: 0 0 48px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
    height: 325px;
    max-width: 577px;
    min-width: 400px;
    margin: 0 30px 0 0;

    ${Body}.right & {
      margin: 0 0 0 30px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin: 0 60px 0 0;

    ${Body}.right & {
      margin: 0 0 0 60px;
    }
  }
`;

export const StyledVideo = styled(ReactYT)`
  height: 100%;
  width: 100%;
  display: ${({ playing }) => (playing ? 'block' : 'none')};
`;

export const ImageWrapper = styled.div`
  position: relative;
  margin: 0 calc(-${themeGet('media.grid-gutter.2')} / 2) 48px;
  width: 100vw;

  height: 235px;

  ${Wrapper}.bottom & {
    margin-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;

    /* height: 450px; */
    height: auto;

    margin: 0 0 48px;

    ${Wrapper}.bottom & {
      display: flex;
      align-items: flex-end;
      height: 100%;
      max-height: 430px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
    height: auto;
    max-width: 577px;
    max-width: 650px;
    margin: 0 30px 0 0;

    ${Body}.right & {
      margin: 0 0 0 30px;
    }

    ${Wrapper}.bottom & {
      height: auto;
      max-height: 100%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin: 0 60px 0 0;

    ${Body}.right & {
      margin: 0 0 0 60px;
    }
  }
`;

// * Styling for the image
export const StyledImage = styled(Image)`
  width: 100%;

  height: 100%;
  object-fit: contain;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 100%;
    object-fit: contain;

    ${Wrapper}.bottom & {
      max-height: 430px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: auto;

    ${Wrapper}.bottom & {
      max-height: 100%;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: 0;
    }
  }

  > p,
  > h1,
  > h2,
  > h3,
  > h4,
  > h5 {
    color: ${themeGet('colors.text-primary')};

    padding-bottom: 30px;

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xs')}) {
    h4 {
      font-weight: 500;
      margin: 0 auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    align-items: flex-start;
    min-width: 350px;
    max-width: 550px;

    h4 {
      margin: 0;
    }

    ${Wrapper}.bottom & {
      padding-bottom: 45px;
    }
  }
`;

export const Title = styled.h2`
  color: ${themeGet('colors.text-primary')};

  padding-bottom: 30px;

  font-size: 26px;

  ${Wrapper}.text-dark & {
    color: ${themeGet('colors.text-secondary')};
  }
  ${Wrapper}.text-light & {
    color: ${themeGet('colors.text-primary')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xs')}) {
    font-size: 20px;
    line-height: 26px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 26px;
    line-height: 34px;
  }
`;

export const List = styled.ul`
  /* for IE */
  max-width: 300px;
  && {
    margin: -40px auto 0;
  }

  li {
    margin: 40px 0;
    display: flex;
    p {
      margin: 0;
    }
  }

  /* setting max-widths for IE */
  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    max-width: 380px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 550px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 450px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    max-width: 550px;
  }
`;

export const Styledlink = styled(Link)`
  /* margin-top: auto; */
  margin-top: 0;

  /* If rendering with list, add margins on the button to align with list content */
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-left: ${({ withList }) => (withList ? '52px' : '0px')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;

  p {
    color: ${themeGet('colors.text-primary')};
  }

  ${Wrapper}.text-dark & {
    p {
      color: ${themeGet('colors.text-secondary')};
    }
  }
  ${Wrapper}.text-light & {
    p {
      color: ${themeGet('colors.text-primary')};
    }
  }

  &::before {
    content: '';
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    height: 36px;
    min-width: 36px;

    margin-right: 16px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;
